import styled from 'styled-components';
import { colors } from '@keen.io/colors';

const OptionHeader = styled.div`
  padding: 0 14px;
  display: flex;
  align-items: center;
  height: 37px;
  background: ${colors.white[500]};
  border-radius: 4px;
  box-sizing: border-box;
`;

export default OptionHeader;
